import React, { useState } from "react";
import { PageLayout } from "@features/shared";
import { usePageInitialization } from "@features/shared/hooks/usePageInitialization";
import { MyWssForm } from "./components";

/**
 * My WSS Feature - Public API
 * 
 * This module exports the main components, hooks, and utilities for the My WSS feature.
 */

// Components
export { MyWssForm } from './components';

// Hooks
export {
  useMyWssState,
  useLocation,
  useWssData,
  useWssCheckIn,
  useWssSummary,
} from './hooks';

// Services
export { myWssService, wssService } from './services';

// Utils
export * from './utils/wssConstants';
export * as gpsUtils from './utils/gpsUtils';

/**
 * MyWssPage - Page wrapper
 * Market working page for WSS management
 * Note: selectedWssCode/selectedWSS state is written by MyWssForm but values are not read here.
 * Kept for potential future use by the form's internal hooks.
 */
export const MyWssPage = () => {
  usePageInitialization();
  const [, setSelectedWssCode] = useState("");
  const [, setSelectedWSS] = useState("");

  return (
    <PageLayout title="Market Working" backPath="/">
      <MyWssForm setSelectedWssCode={setSelectedWssCode} setSelectedWSS={setSelectedWSS} />
    </PageLayout>
  );
};
